import { render, staticRenderFns } from "./ProviderTaskCard.vue?vue&type=template&id=489bfd4e&"
import script from "./ProviderTaskCard.vue?vue&type=script&lang=js&"
export * from "./ProviderTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports